import { Phone, Globe, Clock, Instagram, Facebook } from 'lucide-react'
import type { VenueDetailContactComponent } from '../../../types/sdui-arena-detail'
import { analyticsService } from '@meiuca/analytics'
import { ANALYTICS_EVENTS } from '@/constants/analyticsEvents'

interface VenueDetailContactProps {
  config: VenueDetailContactComponent
}

export function VenueDetailContact({ config }: VenueDetailContactProps) {
  const { phone, whatsapp, website, openingHours, socialMedia } = config

  const trackContactClick = (type: string, value?: string) => {
    analyticsService.track(ANALYTICS_EVENTS.ARENA_DETAIL_CONTACT_CLICKED, {
      contact_type: type,
      contact_value: value
    })
  }

  return (
    <div>
      <h3 className="text-lg font-semibold text-text-primary mb-4">Contato</h3>
      {/* Contact Links */}
      <div className="flex flex-wrap gap-6 mb-4">
        {phone && (
          <a
            href={`tel:${phone}`}
            onClick={() => trackContactClick('phone', phone)}
            className="flex items-center gap-2 text-brand-primary hover:underline"
          >
            <Phone className="w-4 h-4" />
            <span className="text-sm">{phone}</span>
          </a>
        )}
        {whatsapp && (
          <a
            href={`https://wa.me/${whatsapp}`}
            onClick={() => trackContactClick('whatsapp', whatsapp)}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-brand-primary hover:underline"
          >
            <Phone className="w-4 h-4" />
            <span className="text-sm">WhatsApp</span>
          </a>
        )}
        {website && (
          <a
            href={website}
            onClick={() => trackContactClick('website', website)}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-brand-primary hover:underline"
          >
            <Globe className="w-4 h-4" />
            <span className="text-sm">Site oficial</span>
          </a>
        )}
        {openingHours && (
          <div className="flex items-center gap-2 text-text-secondary">
            <Clock className="w-4 h-4" />
            <span className="text-sm">{openingHours}</span>
          </div>
        )}
      </div>

      {/* Social Media Links */}
      {socialMedia && (socialMedia.instagram || socialMedia.facebook) && (
        <div className="flex items-center gap-4">
          <span className="text-sm text-text-secondary">Redes sociais:</span>
          <div className="flex gap-3">
            {socialMedia.instagram && (
              <a
                href={socialMedia.instagram}
                onClick={() => trackContactClick('instagram', socialMedia.instagram)}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full hover:bg-brand-primary/10 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-brand-primary" />
              </a>
            )}
            {socialMedia.facebook && (
              <a
                href={socialMedia.facebook}
                onClick={() => trackContactClick('facebook', socialMedia.facebook)}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full hover:bg-brand-primary/10 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 text-brand-primary" />
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
